export const ROUTES = {
  LOGIN: '/login',
  LOGIN_OKTA: '/login-okta',
  LOGIN_NC_SSO: '/login-nc-sso',
  LOGIN_CCNC_SSO: '/login-ccnc-sso',
  LOGIN_OH_SSO: '/login-oh-sso',
  SSO_ENTRY: '/ccp/dashboard',
  SSO_LOGOUT: '/ssoLogout',
  REDIRECT_SSO: '/ssoRedirect',
  FORGOTUSERNAME: '/forgot-username',
  FORGOTPACCESSCODE: '/forgot-password',
  CHANGEACCESSCODE: '/secure/change-password-profile',
  RESETACCESSCODE: '/change-password',
  DASHBOARD: '/secure/dashboard',
  MEMBERLISTINGLEGACY: '/secure/member-listing',
  MEMBERLISTINGROSTERAPI: '/secure/member-roster',
  MEMBERPAGE: '/secure/member-page',
  // Add other routes here
  TOOLSRESOURCES: '/secure/tools-resources',
  ADMIN: '/secure/admin',
  TUTORIALS: '/secure/tutorials',
  CIIDASHBOARD: '/secure/cii-dashboard',
  CLAIMS: '/secure/claims',
  ADDMEDICATIONS: '/secure/add-medications',
  MEDICAL_CLAIM_DETAILS_OVERVIEW: '/secure/claim-details',
  HEALTH_HISTORY: '/secure/health-history',
  ASSESSMENTS: '/secure/assessments',
  CARETEAM: '/secure/care-team',
  CAREPLAN: '/secure/care-plan',
  CAREGAPS: '/secure/care-gaps',
  UMANAGEMENT: '/secure/management',
  GRIEVANCES: '/secure/grievances',
  CONDITIONS: '/secure/conditions',
  MEMBERACTIONS: '/secure/member-actions',
  NOTES: '/secure/notes',
  MEDICATIONS: '/secure/member-page/medications',
  DOCUMENTS: '/secure/doc-upload',
  VIEWIDCARDS: '/secure/view-id-card',
  SETTINGS: '/secure/settings',
  ONETIMECODE: '/one-time-code',
  AUTHENTICATION: '/authentication',
  PASSWORDEXPIRY: '/password-expiry',
  ACCESSCODECONFIRMATION: '/access-code-confirmation',
  UPLOADUSERS: '/secure/upload',
  SELFREGISTRATION: '/self-registration',
  CHANGEPCP: '/secure/changepcp',
  CONTACTUS: '/secure/contact-us',
  NEWENROLLMENT: '/secure/new-enrollment',
  NEWENROLLMENTCONFIRMATION: '/secure/new-enrollment-confirmation',
  CALENDAR: '/secure/calendar',
  PHARMACY: '/secure/pharmacy-dashboard',
  ALLPRESCRIPTIONS: '/secure/member-page/pharmacy/allprescriptions',
  RRTForm: '/secure/rrt-form',
  MANAGEINTERNALUSERS: '/secure/manage-internal-users',
  SURVEY: '/secure/survey'
};
